// src/infra/api/Amostras.js
import axiosInstance from "../axios";

export const StatusAmostra = {
    PENDENTE: "PENDENTE",
    EM_PROCESSAMENTO: "EM_PROCESSAMENTO",
    ENCERRADA: "ENCERRADA",
};

const buildAmostraFilter = (filter = {}) => {
    const payload = {};

    if (filter.identificacao) payload.identificacao = filter.identificacao;
    if (filter.status) payload.status = filter.status;

    if (filter.torreId) payload.torreId = filter.torreId;
    if (filter.numeroSerieTorre) payload.numeroSerieTorre = filter.numeroSerieTorre;

    if (filter.createdFrom)
        payload.createdFrom =
            typeof filter.createdFrom === "string" ? filter.createdFrom : filter.createdFrom.toISOString();

    if (filter.createdTo)
        payload.createdTo = typeof filter.createdTo === "string" ? filter.createdTo : filter.createdTo.toISOString();

    // Lixeira (soft-delete): true => lista SOMENTE as análises excluídas. Só ADMIN
    // (o backend ignora esse flag para não-ADMIN).
    if (filter.apenasExcluidas) payload.apenasExcluidas = true;

    return payload;
};

export const criarAmostra = async (payload) => {
    try {
        const response = await axiosInstance.post("/amostras", payload);
        return response.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Falha ao criar amostra.");
    }
};

export const atualizarAmostra = async (id, payload) => {
    try {
        const response = await axiosInstance.put(`/amostras/${id}`, payload);
        return response.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Falha ao atualizar amostra.");
    }
};

export const listarAmostras = async (filter = {}, page = 0, size = 10, sort = "createdAt,desc") => {
    try {
        const payload = buildAmostraFilter(filter);
        const response = await axiosInstance.post(`/amostras/search?page=${page}&size=${size}&sort=${sort}`, payload);
        return response.data;
    } catch (error) {
        console.error("Falha ao listar amostras:", error);
        throw error;
    }
};

export const buscarAmostraPorId = async (id) => {
    try {
        const response = await axiosInstance.get(`/amostras/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Amostra não encontrada.");
    }
};

// Soft-delete: exige motivo (backend responde 400 sem motivo). ADMIN+GESTOR.
export const excluirAmostra = async (id, motivo = "") => {
    try {
        const response = await axiosInstance.delete(`/amostras/${id}`, { params: { motivo } });
        return response.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Falha ao excluir análise.");
    }
};

// Restaurar (undo soft-delete). Só ADMIN (backend responde 403 caso contrário).
export const restaurarAmostra = async (id) => {
    try {
        const response = await axiosInstance.put(`/amostras/${id}/restaurar`);
        return response.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Falha ao restaurar análise.");
    }
};

// Acrescenta um comentário à análise. Qualquer papel autenticado pode comentar, em
// qualquer status — só análise excluída é recusada (409). Devolve a Amostra atualizada,
// para a tela fazer merge em memória em vez de recarregar a listagem inteira.
export const adicionarComentarioAmostra = async (id, comentario) => {
    try {
        const response = await axiosInstance.post(`/amostras/${id}/comentarios`, {
            comentario,
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error?.response?.data?.message || "Falha ao adicionar comentário."
        );
    }
};

export const buscarAmostraDetalhes = async (id) => {
    try {
        const resp = await axiosInstance.get(`/amostras/${id}/detalhes`);
        return resp.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Falha ao buscar detalhes da amostra.");
    }
};

export const criarAmostraMock = async (payload) => {
    try {
        const response = await axiosInstance.post("/amostras/mock", payload);
        return response.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Falha ao criar amostra mock.");
    }
};

export const normalizarAmostrasPorDia = async (payload) => {
    try {
        const response = await axiosInstance.post("/amostras/normalizar-dia", payload);
        return response.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Falha ao normalizar amostras por dia.");
    }
};

export default {
    criarAmostraMock, // <-- add
    normalizarAmostrasPorDia,
    criarAmostra,
    atualizarAmostra,
    listarAmostras,
    buscarAmostraPorId,
    excluirAmostra,
    restaurarAmostra,
    adicionarComentarioAmostra,
    buscarAmostraDetalhes,
    StatusAmostra,
};
